export default __webpack_public_path__ + "static/media/note-clip-path.7759e6d3.svg";